import { Routes } from '@angular/router';
import { AuthGuard } from './core/guards/auth.guard';

export const routes: Routes = [
  {
    path: 'auth',
    loadChildren: () =>
      import('./features/auth/routes').then((m) => m.AuthRoutes),
  },
  {
    path: '',
    canActivate: [AuthGuard],
    loadComponent: () =>
      import('./core/Layout/Layout.component').then((c) => c.LayoutComponent),
    children: [
      {
        path: '',
        canActivate: [AuthGuard],
        loadChildren: () =>
          import('./features/organizations/routes').then(
            (m) => m.OrganizationsRoutes
          ),
      },
      {
        path: 'devices',
        canActivate: [AuthGuard],
        loadChildren: () =>
          import('./features/devices/routes').then((m) => m.DevicesRoutes),
      },
      {
        path: 'rfid',
        canActivate: [AuthGuard],
        loadComponent: () =>
          import('./features/rfid/rfid.component').then((c) => c.RfidComponent),
      },
      {
        path: 'dev-tools',
        canActivate: [AuthGuard],
        loadChildren: () =>
          import('./features/dev-tools/routes').then((m) => m.DevToolsRoutes),
      },
      {
        path: 'widget',
        canActivate: [AuthGuard],
        loadComponent: () =>
          import('./features/help-widget/help-widget').then((c) => c.HelpWidget),
      }
    ],
  },
];
